import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=65768393"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=65768393&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports